import * as React from "react";
import { Grid } from "@mui/material";
import logo from "../../assets/FERROEXPRESO.svg";

const Ppal = () => {
  return (
    <React.Fragment>
      <Grid
        container
        spacing={0}
        direction="column"
        sx={{
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          minHeight: "100vh",
        }}
      >
        <Grid size={4}>
          <img src={logo} width={"100%"} alt="FerroExpreso Pampeano" />
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default Ppal;
